import { render, staticRenderFns } from "./ShopBundleDiscountRecord.vue?vue&type=template&id=24ba8548&"
import script from "./ShopBundleDiscountRecord.vue?vue&type=script&lang=js&"
export * from "./ShopBundleDiscountRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports